import { render } from "./SettlementAdvanceTemplate.vue?vue&type=template&id=bcf6b844"
import script from "./SettlementAdvanceTemplate.vue?vue&type=script&lang=js"
export * from "./SettlementAdvanceTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__